import React, { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext(null);

const STORAGE_KEY = "fi-token";

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    // 1. Check URL for token (OAuth callback)
    const params = new URLSearchParams(window.location.search);
    const urlToken = params.get("token");

    if (urlToken) {
      login(urlToken);
      // Clean URL
      window.history.replaceState({}, document.title, window.location.pathname);
    } else {
      // 2. Check LocalStorage
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        setToken(saved);
        try {
          const payload = JSON.parse(atob(saved.split('.')[1]));
          setUser(payload);
        } catch (e) {
          console.error("Failed to parse token", e);
          localStorage.removeItem(STORAGE_KEY);
        }
      }
    }
  }, []);

  const login = (value) => {
    setToken(value);
    localStorage.setItem(STORAGE_KEY, value);
    try {
      const payload = JSON.parse(atob(value.split('.')[1]));
      setUser(payload);
    } catch (e) {
      console.error("Failed to parse token", e);
    }
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem(STORAGE_KEY);
  };

  return (
    <AuthContext.Provider value={{ token, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
